/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ResultType = {
    Balance: 'balance',
    Entry: 'entry'
} as const;
export type ResultType = typeof ResultType[keyof typeof ResultType];


export function instanceOfResultType(value: any): boolean {
    for (const key in ResultType) {
        if (Object.prototype.hasOwnProperty.call(ResultType, key)) {
            if (ResultType[key as keyof typeof ResultType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ResultTypeFromJSON(json: any): ResultType {
    return ResultTypeFromJSONTyped(json, false);
}

export function ResultTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultType {
    return json as ResultType;
}

export function ResultTypeToJSON(value?: ResultType | null): any {
    return value as any;
}

export function ResultTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ResultType {
    return value as ResultType;
}

